import { render, staticRenderFns } from "./BButtonVerifyForm.vue?vue&type=template&id=cef6d566&"
import script from "./BButtonVerifyForm.vue?vue&type=script&lang=js&"
export * from "./BButtonVerifyForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports